import React, { useState } from "react";

import { useTranslation } from "utils";

import { Input, Modal } from "components";

type ZipCodeModalProps = {
  existingZipCode: string;
  open: boolean;
  onClose: () => void;
  onFinish: (zipCode: string) => void;
};

export const ZipCodeModal = ({ existingZipCode, open, onClose, onFinish }: ZipCodeModalProps) => {
  const { t } = useTranslation("cropExplorer");

  const [zipCode, setZipCode] = useState<string>(existingZipCode);

  return (
    <Modal
      dataTestId="crop-explorer-tab-zip-code-modal"
      title={t("zipCodeModal.title")}
      content={
        <>
          <p>{t("zipCodeModal.description")}</p>
          <Input
            className="margin-top-100"
            label={t("cropExplorer:onboardingModal.locationFormZipCodeInputPlaceholder")}
            rules={[{ required: true }]}
            value={zipCode}
            initialValue={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
          />
        </>
      }
      okText={t("zipCodeModal.save")}
      cancelText={t("zipCodeModal.cancel")}
      onOk={() => onFinish(zipCode)}
      showModal={open}
      onCancel={onClose}
      destroyOnHidden={true}
    />
  );
};
